import React from 'react';
import PropTypes from 'prop-types';

function CheckBox(props) {
  const { field, label } = props;

  const { name, onChange, onBlur, value } = field;
  return (
    <div>
      <input
        name={name}
        type="checkbox"
        value={value}
        checked={value}
        onChange={onChange}
        onBlur={onBlur}
      />{' '}
      <label>{label}</label>
    </div>
  );
}
CheckBox.propTypes = {
  field: PropTypes.object.isRequired,
  label: PropTypes.string
};
export default CheckBox;
